export enum Territory {
    AUSTRALIA = 'Australia',
    UNITEDKINGDOM = 'UnitedKingdom'
}